import { colorClass } from "../lib/lotto.js";

export default function Ball({ n }) {
  return <span className={colorClass(n)}>{n}</span>;
}

export function BallRow({ nums, label }) {
  return (
    <div className="row">
      {label && <span className="muted" style={{ minWidth: 80 }}>{label}</span>}
      {nums.map((n, i) => (
        <Ball key={i} n={n} />
      ))}
    </div>
  );
}
